module.exports = __webpack_public_path__ + "img/title-ja.a38e5823.png";